export default "__VITE_ASSET__f7c6d401__"